import { UndercutDegreeOption } from '../../model';

export const UndercutDegreeOptions: UndercutDegreeOption[] = [
    { label: '-5', value: -5 },
    { label: '0', value: 0 },
    { label: '5', value: 5 },
    { label: '10', value: 10 },
    { label: '15', value: 15 },
];
